/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmissionHistoryResponse } from './PalReauthSubmissionHistoryResponse';
import {
    PalReauthSubmissionHistoryResponseFromJSON,
    PalReauthSubmissionHistoryResponseFromJSONTyped,
    PalReauthSubmissionHistoryResponseToJSON,
    PalReauthSubmissionHistoryResponseToJSONTyped,
} from './PalReauthSubmissionHistoryResponse';

/**
 * 
 * @export
 * @interface GetPalReauthSubmissionHistory200Response
 */
export interface GetPalReauthSubmissionHistory200Response {
    /**
     * 
     */
    data?: PalReauthSubmissionHistoryResponse;
}

/**
 * Check if a given object implements the GetPalReauthSubmissionHistory200Response interface.
 */
export function instanceOfGetPalReauthSubmissionHistory200Response(value: object): value is GetPalReauthSubmissionHistory200Response {
    return true;
}

export function GetPalReauthSubmissionHistory200ResponseFromJSON(json: any): GetPalReauthSubmissionHistory200Response {
    return GetPalReauthSubmissionHistory200ResponseFromJSONTyped(json, false);
}

export function GetPalReauthSubmissionHistory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPalReauthSubmissionHistory200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalReauthSubmissionHistoryResponseFromJSON(json['data']),
    };
}

export function GetPalReauthSubmissionHistory200ResponseToJSON(json: any): GetPalReauthSubmissionHistory200Response {
    return GetPalReauthSubmissionHistory200ResponseToJSONTyped(json, false);
}

export function GetPalReauthSubmissionHistory200ResponseToJSONTyped(value?: GetPalReauthSubmissionHistory200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthSubmissionHistoryResponseToJSON(value['data']),
    };
}

